import React from "react";
import { createRoot } from "react-dom/client";
import "./i18n";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { ConfigProvider } from "@/contexts/ConfigContext";
import { MixpanelProvider } from "@/contexts/MixpanelProvider";
import { AuthProvider } from "@/hooks/AuthProvider";
import { queryClient } from "./lib/queryClient";
import { router } from "./lib/router";

export function App() {
  return (
    <ConfigProvider>
      <MixpanelProvider>
        <RouterProvider router={router} />
      </MixpanelProvider>
    </ConfigProvider>
  );
}

createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
